import Image from "next/image";
import Link from "next/link";
import { useState } from "react";
import { usePathname } from "next/navigation";
import useMetadataStore from "@/store/metadata.store";

export default function Header1() {
  const [isToggled, setIsToggled] = useState(false);
  const pathname = usePathname();
  const { data } = useMetadataStore();

  const handleToggle = () => {
    setIsToggled((prev) => !prev);
  };

  return (
    <header
      className="header bg-white"
      style={{ height: isToggled ? "auto" : "90px" }}
    >
      <div className="container flex justify-between items-start">
        {/* Logo */}
        <div className="logo lg:mt-0 mt-3">
          {data?.customer.logo && (
            <Link
              href="/"
              className="flex align-items-end"
              style={{ textDecoration: "none" }}
            >
              <Image
                src={data?.customer.logo}
                alt="Logo"
                width={0}
                height={0}
                style={{ width: "auto", height: "65px" }}
              />
              {/* <h2
              className="ml-2"
              style={{
                textDecoration: "none",
                color: "#333",
                fontFamily: "Montserrat",
                marginBottom: "-5px",
              }}
            >
              {data?.customer.name}
            </h2> */}
            </Link>
          )}
        </div>

        <div
          className={`burger-menu lg:hidden cursor-pointer ${
            isToggled ? "menu-open" : ""
          }`}
          onClick={handleToggle}
        >
          <div className="line-menu line-half first-line bg-black h-1 mb-1"></div>
          <div className="line-menu bg-black h-1 mb-1"></div>
          <div className="line-menu line-half last-line bg-black h-1"></div>
        </div>

        {/* Navigation */}
        <nav className={`navik-menu ${isToggled ? "block" : "hidden"} lg:flex`}>
          <ul className="flex flex-col lg:flex-row lg:space-x-8 md:mt-2">
            <li className="navItem">
              <Link
                href="/"
                className={` dropdown-menu-link ${
                  pathname === "/" ? "active" : ""
                }`}
              >
                Home
              </Link>
            </li>
            <li className="navItem">
              <Link
                href="/about"
                className={` dropdown-menu-link ${
                  pathname === "/about" ? "active" : ""
                }`}
              >
                About
              </Link>
            </li>
            <li className="navItem">
              <Link
                href="/contact-us"
                className={` dropdown-menu-link ${
                  pathname === "/contact-us" ? "active" : ""
                }`}
              >
                Contact Us
              </Link>
            </li>
          </ul>
        </nav>
      </div>

      <ul
        className={`dropdown-menu-container ${
          isToggled ? "d-block d-flex flex-col justify-center" : "d-none"
        }`}
      >
        <li className="dropdown-menu-item">
          <Link
            prefetch={false}
            href="/"
            className={`dropdown-menu-link ${pathname === "/" ? "active" : ""}`}
          >
            Home
          </Link>
        </li>
        <li className="dropdown-menu-item">
          <Link
            prefetch={false}
            href="/about"
            className={`dropdown-menu-link ${
              pathname === "/about" ? "active" : ""
            }`}
          >
            About
          </Link>
        </li>
        <li className="dropdown-menu-item">
          <Link
            prefetch={false}
            href="/contact-us"
            className={`dropdown-menu-link ${
              pathname === "/contact-us" ? "active" : ""
            }`}
          >
            Contact Us
          </Link>
        </li>
      </ul>
    </header>
  );
}
